module.exports = __webpack_public_path__ + "static/media/ic_customer_portal.c35206ad.svg";